export default {
  name: 'popwrap',
  props: {
    txt: {
      type: String,
      default: ''
    },
    mb: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  components: {},
  methods: {
    clickPop: function clickPop() {
      this.$emit('clickPop');
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};